import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SUPPORT_CREATE,
} from "./actionTypes.js";

import {
    getSupportCreateSuccess,
    getSupportCreateFail,
} from "./actions.js";

import { supportCreateApi } from "./supportApi.js";

function* fetchSupportCreate({ payload }) {
    try {
        const response = yield call(supportCreateApi, payload);
        yield put(getSupportCreateSuccess(response));
    } catch (error) {
        yield put(getSupportCreateFail(error));
    }
}

function* SupportSaga() {
    yield takeEvery(GET_SUPPORT_CREATE, fetchSupportCreate);
}

export default SupportSaga